export const smartRingTranslations = {
    fa: {
        title: "مقایسه حلقه‌های هوشمند",
        subtitle: "دلبند",
        description: "ویژگی‌های حلقه‌های هوشمند مختلف دلبند را مقایسه کنید تا بهترین انتخاب را برای نیازهای خود داشته باشید.",
    },
    en: {
        title: "Smart Ring Comparison",
        subtitle: "Delband",
        description: "Compare different Delband smart rings features to make the best choice for your needs.",
    },
    ar: {
        title: "مقارنة الخواتم الذكية",
        subtitle: "دلبند",
        description: "قارن بين ميزات خواتم دلبند الذكية المختلفة لاتخاذ الخيار الأفضل لاحتياجاتك.",
    },
    tr: {
        title: "Akıllı Yüzük Karşılaştırması",
        subtitle: "Delband",
        description: "İhtiyaçlarınız için en iyi seçimi yapmak üzere farklı Delband akıllı yüzük özelliklerini karşılaştırın.",
    },
};
